module.exports = __webpack_public_path__ + "static/media/muscleaider-1.341572fa.png";